import axios from "axios";
import { createAuthenticatedAxiosInstance } from "../auth/auth.slice";

const baseUrl = import.meta.env.VITE_API_URL;

export const salesService = {
  getAllSales: async (params) => {
    const axiosInstance = createAuthenticatedAxiosInstance();
    const response = await axiosInstance.get(baseUrl + "sales", { params });
    return response.data;
  },

  addSale: async (saleData) => {
    const axiosInstance = createAuthenticatedAxiosInstance();
    const response = await axiosInstance.post(baseUrl + "sales", saleData);
    return response.data;
  },

  getSaleDetails: async (id) => {
    const axiosInstance = createAuthenticatedAxiosInstance();
    const response = await axiosInstance.get(`${baseUrl}sales/${id}`);
    return response.data;
  },

  processReturn: async (id, data) => {
    const axiosInstance = createAuthenticatedAxiosInstance();
    const response = await axiosInstance.post(`${baseUrl}sales/${id}/return`, data);
    return response.data;
  },

  addPayment: async (paymentData) => {
    const axiosInstance = createAuthenticatedAxiosInstance();
    const response = await axiosInstance.post(`${baseUrl}payments`, paymentData);
    return response.data;
  },

  getSalePayments: async (saleId) => {
    const axiosInstance = createAuthenticatedAxiosInstance();
    const response = await axiosInstance.get(`${baseUrl}payments/sale/${saleId}`);
    return response.data;
  },

  generateInvoice: async (saleId) => {
    const axiosInstance = createAuthenticatedAxiosInstance();
    const response = await axiosInstance.get(
      `${baseUrl}sales/${saleId}/invoice`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  },

  generateReceipt: async (saleId) => {
    const axiosInstance = createAuthenticatedAxiosInstance();
    const response = await axiosInstance.get(
      `${baseUrl}sales/${saleId}/receipt`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  },

  // Draft methods
  getDrafts: async () => {
    const axiosInstance = createAuthenticatedAxiosInstance();
    const response = await axiosInstance.get(`${baseUrl}sales/drafts/list`);
    return response.data;
  },

  createDraft: async (draftData) => {
    const axiosInstance = createAuthenticatedAxiosInstance();
    const response = await axiosInstance.post(`${baseUrl}sales/drafts`, draftData);
    return response.data;
  },

  updateDraft: async (id, draftData) => {
    const axiosInstance = createAuthenticatedAxiosInstance();
    const response = await axiosInstance.put(`${baseUrl}sales/drafts/${id}`, draftData);
    return response.data;
  },

  convertDraftToSale: async (id) => {
    const axiosInstance = createAuthenticatedAxiosInstance();
    const response = await axiosInstance.post(`${baseUrl}sales/drafts/${id}/convert`);
    return response.data;
  },

  deleteDraft: async (id) => {
    const axiosInstance = createAuthenticatedAxiosInstance();
    const response = await axiosInstance.delete(`${baseUrl}sales/drafts/${id}`);
    return response.data;
  },
};
